// extracted by mini-css-extract-plugin
export var arrows = "_76-6";
export var decrementer = "_76-a";
export var disabled = "_76-4";
export var error = "_76-1";
export var hiddenText = "_76-b";
export var incrementer = "_76-9";
export var input = "_76-8";
export var inputWrapper = "_76-0";
export var leadingIcon = "_76-c";
export var readonly = "_76-3";
export var regular = "_76-7";
export var small = "_76-5";
export var warning = "_76-2";